import { addRecoilKey } from '@infield/utils/recoil';
import { atom } from 'recoil';

import type { AssetExplorationViews } from './types';

export const selectedAssetViewAtom = atom<AssetExplorationViews | ''>({
  key: addRecoilKey('asset-info-selected-view'),
  default: '',
});
